// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"3d8de8f1","345":"703c678d"}[chunkId] + ".chunk.js";
};